import { useQuery } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import { getPortfolioIdReportingV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePortfolioIdReportingQuery = (id: number) => {
	return useQuery({
		queryKey: PortfolioKeys.reporting(id),
		queryFn: processResponse(() => getPortfolioIdReportingV2(id)),
	});
};
